'use client'

import { useMemo } from 'react'

import { Category } from 'modules/Category/model/types'
import { CategoryItem } from 'modules/Category/ui/CategoryItem/Desktop'

import styles from './CategoryList.module.scss'

interface CategoryListProps {
  category?: Category
}

export function CategoryList({ category }: CategoryListProps) {
  const columns = useMemo(() => {
    if (!category?.children) return [[], [], []]
    return category.children.reduce<Category[][]>(
      (acc, item, index) => {
        acc[index % 3].push(item)
        return acc
      },
      [[], [], []],
    )
  }, [category])

  return (
    <div className={styles.wrapper}>
      <div className={styles.categoryHeader}>
        <h2 className={styles.title}>{category?.name}</h2>
      </div>
      <div className={styles.masonryGrid}>
        {columns.map((column, colIndex) => (
          <div key={colIndex} className={styles.masonryColumn}>
            {column.map(item => (
              <CategoryItem key={item.id} {...item} />
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}
